<!-- Normal spacing mode -->
<div class="icon-grid" data-identifier="property-alignment" *ngIf="spacing !== 'auto'">
  <button *ngFor="let icon of icons"
          class="icon-cell"
          [class.active]="selectedIcon === icon"
          [attr.data-pos]="icon"
          (mouseenter)="hoveredIcon = icon"
          (mouseleave)="hoveredIcon = null"
          (click)="setIcon(icon)">
    <span class="dot" *ngIf="selectedIcon !== icon && hoveredIcon !== icon"></span>
    <i *ngIf="selectedIcon === icon || hoveredIcon === icon"
         class="icon-img wms"
         [ngClass] ="getIconClass(icon)"
         [title]="icon" ></i>
  </button>
</div>

<!-- Auto spacing mode -->
<div class="icon-grid" data-identifier="property-alignment" *ngIf="spacing === 'auto'">
  <div *ngFor="let position of positions"
       class="icon-cell"
       [class.active]="selectedIcon === getAlignment(position)"
       [attr.data-row]="position.row"
       [attr.data-col]="position.col"
       (mouseenter)="hoveredIcon = getAlignment(position)"
       (mouseleave)="hoveredIcon = null"
       (click)="setIcon(getAlignment(position))">

    <!-- Default dot -->
    <span class="dot" *ngIf="shouldShowIcon(position) === 'dot'"></span>

    <!-- Icon -->
    <i *ngIf="shouldShowIcon(position) === 'icon'" class="wms spacing-auto-{{direction}}"
         [ngClass]="getIconClass(position)"
         [title]="getAlignment(position)"></i>
  </div>
</div>
